"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdSurveyMultipleChoice = require("cccisd-survey-multiple-choice");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("cccisd-survey-multiple-choice/src/Player/style.css"));
var _filterProps = _interopRequireDefault(require("../filterProps.js"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Component = function Component(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyMultipleChoice.Player, _extends({}, (0, _filterProps["default"])(props), {
    isMatrixMode: true
  }));
};

// eslint-disable-next-line react/prop-types
var renderHeader = function renderHeader(_ref) {
  var settings = _ref.settings,
    column = _ref.column,
    accommodations = _ref.accommodations,
    setParameters = _ref.setParameters;
  if (!settings.showLabelsInMatrixHeader || settings.visualType === 'button' || settings.visualType === 'dropdown') {
    return null;
  }
  var headerStyle = column.label ? {
    borderTop: '1px solid #dddddd',
    marginTop: '.5em',
    paddingTop: '.5em'
  } : {};
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: headerStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].matrixValuesWrapper
  }, settings.options.map(function (option, index) {
    var optionType = settings.optionTypes[option.type].find(function (item) {
      return item.id === option.id;
    }) || {};
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: option.id,
      style: {
        width: "".concat(100 / settings.options.length, "%")
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: option.label,
      accommodations: accommodations,
      setParameters: setParameters
    }), optionType.tooltip && /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].tooltip
    }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: optionType.tooltip
    }, /*#__PURE__*/_react["default"].createElement(_question["default"], null))));
  })));
};
var _default = {
  component: Component,
  validate: _cccisdSurveyMultipleChoice.playerValidate,
  getInitialValue: _cccisdSurveyMultipleChoice.getPlayerInitialValue,
  renderHeader: renderHeader
};
exports["default"] = _default;